import React from 'react';

// Objects passed into component must implement interface

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface ICheckBox {
    isSelected: boolean;
    label?: string;
}

export type CHECKBOX_GROUP_TYPES =
    | 'GRADE'
    | 'YEAR'
    | 'CONTENT_CLASSIFICATION'
    | 'ITEM_TYPE'
    | 'DIFFICULTY_LEVEL'
    | 'JURIS_INFO'
    | 'VARIABLE_LIST'
    | 'SUBGROUPS_LIST'
    | 'STAT_LIST'
    | 'DOWNLOAD_TAB'
    | 'DOWNLOAD_TEST'
    | 'EXCEL_OPTION'
    | 'CALCULATOR_TYPE'
    | 'INCLUDE_SCORE_GUIDES'

export function isCHECKBOX_GROUP_TYPES(str: string): str is CHECKBOX_GROUP_TYPES {
  return (
    str === 'GRADE' ||
        str === 'YEAR' ||
        str === 'CONTENT_CLASSIFICATION' ||
        str === 'ITEM_TYPE' ||
        str === 'DIFFICULTY_LEVEL' ||
        str === 'JURIS_INFO' ||
        str === 'VARIABLE_LIST' ||
        str === 'SUBGROUPS_LIST' ||
        str === 'STAT_LIST' ||
        str === 'DOWNLOAD_TAB' ||
        str === 'DOWNLOAD_TEST' ||
        str === 'EXCEL_OPTION' ||
        str === 'CALCULATOR_TYPE'
  );
}
export interface NQTCheckBoxProps {
    checkBoxObj: ICheckBox;
    children?: JSX.Element|JSX.Element[]|boolean;
    containerClass?: string;
    containerStyle?: React.CSSProperties;
    hideLabel?: boolean;
    id: string;
    isIndeterminate?: boolean;
    isMixed?: boolean;
    ariaControls?: string;
    label?: string | number | undefined;
    type?: CHECKBOX_GROUP_TYPES;
    disabled?: boolean;
    // eslint-disable-next-line @typescript-eslint/ban-types
    updateHandler?: Function;
  }